/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpSharedShippingInfoLink_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpSharedBlurbShipping_user$ref: FragmentReference;
export type PdpSharedBlurbShipping_user = {|
  +isVerifiedTrade: ?boolean,
  +$fragmentRefs: PdpSharedShippingInfoLink_user$ref,
  +$refType: PdpSharedBlurbShipping_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpSharedBlurbShipping_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isVerifiedTrade",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingInfoLink_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '692ffbf80bf5c2738dee5a2bebd95949';
module.exports = node;
